module.exports = __webpack_public_path__ + "static/14-8ce24abe2ebe01fc9aabe5618a7d709a.wav";